import pathfinder from '@fiverr-private/pathfinder';

export interface CategoryLink {
    title: string;
    href: string;
    badge?: string;
}

export const CATEGORY_LINKS: CategoryLink[] = [
    {
        title: 'website development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'book publishing',
        href: pathfinder(
            'content_pages_page',
            { page_slug: 'books-publishing' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'POPULAR',
    },
    {
        title: 'social media marketing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'online-marketing', id: 'social-marketing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'AI development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'ai-coding' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'POPULAR',
    },
    {
        title: 'architecture & interior design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'architectural-design-services' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'mobile app development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'mobile-app-services' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'UGC videos',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'ugc-videos' },
            { query: { source: 'category_tree' } }
        ),
    },
];
